import React from 'react';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

interface ISingleResultRow {
  keyVal?: number;
  transaction?: any;
  handleEdit?: any;
  handleDelete?: any;
}

const ProductChildRow: React.FC<ISingleResultRow> = ({
  keyVal = Math.floor(Math.random()),
  transaction,
  handleDelete,
  handleEdit,
}) => {
  return (
    <>
      <div className='screening-results-row' key={keyVal}>
        <div className='screening-results-row-default-cell'>
          <div className='screening-results-row-default-cell-inner'>
            <div className='screening-results-row-link-cell-text'>
              {transaction?.name ?? ''}
            </div>
          </div>
        </div>
        <div className='screening-results-row-default-cell'>
          <div className='screening-results-row-default-cell-inner'>
            <div className='screening-results-row-default-cell-text'>
              {transaction?.email ?? ''}
            </div>
          </div>
        </div>
        <div className='screening-results-row-default-cell'>
          <div className='screening-results-row-default-cell-inner'>
            <div className='screening-results-row-default-cell-text'>
              {transaction?.contact_type ?? ''}
            </div>
          </div>
        </div>
        <div className='screening-results-row-default-cell'>
          <div className='screening-results-row-default-cell-inner'>
            <div className='screening-results-row-default-cell-text'>
              {transaction?.created_at
                ? new Date(transaction.created_at).toLocaleDateString()
                : ''}
            </div>
          </div>
        </div>
        <div className='screening-results-row-default-cell'>
          <div className='screening-results-row-default-cell-inner'>
            <div className='screening-results-row-default-cell-text'>
              {transaction?.updated_at
                ? new Date(transaction.updated_at).toLocaleDateString()
                : ''}
            </div>
          </div>
        </div>
        <div
          className='screening-results-row-default-cell'
          style={{ maxWidth: '100px', paddingLeft: '0px' }}
        >
          <div className='screening-results-row-default-cell-inner'>
            <EditOutlinedIcon
              onClick={() => handleEdit(transaction ? transaction : {})}
              sx={{ fontSize: 20, color: 'var(--card-text)' }}
            />
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='20'
              height='20'
              viewBox='0 0 20 20'
              fill='none'
              onClick={() => handleDelete(transaction ? transaction : {})}
            >
              <path
                d='M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5M8.33333 8.75V12.9167M11.6667 8.75V12.9167'
                stroke='var(--card-text)'
                strokeWidth='1.66667'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductChildRow;
